// extracted by mini-css-extract-plugin
module.exports = {"tooltitle":"Tools_tooltitle__2lRz7"};